(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["threadheads-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.th-product').forEach((root) => {
    const mainImage = root.querySelector('.th-product__main-image');
    root.querySelectorAll('.th-product__thumb').forEach((button) => button.addEventListener('click', () => {
      const image = button.querySelector('img');
      if (!image || !mainImage) return;
      mainImage.src = image.currentSrc || image.src;
      mainImage.srcset = '';
      root.querySelectorAll('.th-product__thumb').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    }));
    const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
    const form = root.querySelector('.th-product__form');
    form.addEventListener('change', () => {
      const selected = [...form.querySelectorAll('[data-option-position]:checked')].sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      form.querySelectorAll('[data-option-position]:checked').forEach((input) => { const current = root.querySelector(`[data-option-current="${input.dataset.optionPosition}"]`); if (current) current.textContent = input.value; });
      if (!variant) return;
      form.querySelector('[data-variant-id]').value = variant.id;
      const addButton = form.querySelector('[data-add-to-cart]');
      addButton.disabled = !variant.available;
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    });
    const dialog = root.querySelector('[data-size-chart]');
    root.querySelectorAll('[data-size-chart-open]').forEach((button) => button.addEventListener('click', () => dialog.showModal()));
    root.querySelector('[data-size-chart-close]')?.addEventListener('click', () => dialog.close());
  });

  } catch(e) { console.error(e); }
})();
})();
